/**
 * Sort employees by first name, then by last name if first names are equal.
 * @param {Array} employees - Array of employee objects
 * @param {Object} options - Optional configuration for property names
 * @param {string} options.firstNameKey - Property name for first name (default: 'first_name')
 * @param {string} options.lastNameKey - Property name for last name (default: 'last_name')
 * @returns {Array} - New sorted array (does not mutate original)
 */
export const sortEmployeesByName = (
  employees,
  {firstNameKey = 'first_name', lastNameKey = 'last_name'} = {},
) => {
  return [...employees].sort((a, b) => {
    const firstNameCompare = a[firstNameKey].localeCompare(b[firstNameKey]);
    if (firstNameCompare !== 0) return firstNameCompare;
    return a[lastNameKey].localeCompare(b[lastNameKey]);
  });
};